import React from "react";
import { Modal, Button } from "react-bootstrap";

const ProfileImgPreview = ({
  setModalShow,
  photoUrl,
  modalShow,
  setShowResumeUpload,
  setPhoto,
}) => {
  return (
    <Modal show={modalShow} centered id="showpreview">
      <Modal.Body>
        <img width="50" height="50" src={photoUrl} alt="User Name" />
      </Modal.Body>
      <Modal.Footer>
        <Button
          variant="secondary"
          onClick={() => {
            setModalShow(false);
          }}
        >
          Close
        </Button>

        <Button
          variant="primary"
          onClick={() => {
            setModalShow(false);
            setShowResumeUpload(true);
          }}
        >
          Re-Upload
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ProfileImgPreview;
